export default "__VITE_ASSET__FccFKziB__"